import { createStore } from "redux";
import rootReducer from "./reducers/index.js";
import { loadState, saveState } from "./localStorage.js";
import throttle from 'lodash/throttle'

const initialState = loadState();
const store = createStore(rootReducer, initialState);
store.subscribe(throttle(()=>{
    saveState({entries: store.getState().entryReducer.entries});
}, 1000));

export default store;
